'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
import { useEffect, useState } from 'react';
/**
 * Loader component that displays a loading animation.
 */
export function Loader({ className, delay = 500, }) {
    const [showLoader, setShowLoader] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowLoader(true);
        }, delay);
        return () => clearTimeout(timer);
    }, [delay]);
    if (!showLoader) {
        return null;
    }
    return (_jsx("div", { className: clsx('flex h-full items-center justify-center', className), children: _jsxs("div", { className: "flex items-center space-x-2", children: [_jsx("div", { className: "h-3 w-3 animate-pulse rounded-full bg-brand-background-primary" }), _jsx("div", { className: "h-3 w-3 animate-pulse rounded-full bg-brand-background-primary", style: { animationDelay: '300ms' } }), _jsx("div", { className: "h-3 w-3 animate-pulse rounded-full bg-brand-background-primary", style: { animationDelay: '600ms' } })] }) }));
}
//# sourceMappingURL=Loader.js.map